export default function CaseResults() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="cases" className="py-20 md:py-28 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6">
            Реальные результаты клиентов
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Все результаты достигнуты после обучения сотрудников и сопровождения внедрения.
          </p>
        </div>

        <div className="space-y-8 max-w-4xl mx-auto">
          {/* Case 1 */}
          <div className="bg-white rounded-2xl p-8 md:p-10 shadow-sm">
            <div className="flex items-center gap-4 mb-6">
              <div className="w-14 h-14 bg-teal-600 rounded-xl flex items-center justify-center flex-shrink-0">
                <i className="ri-ship-line text-2xl text-white"></i>
              </div>
              <div>
                <h3 className="text-xl md:text-2xl font-bold text-gray-900">Международная логистическая компания</h3>
                <p className="text-gray-500 text-sm">B2B, комплексное сопровождение</p>
              </div>
            </div>
            <div className="grid sm:grid-cols-2 gap-4 mb-6">
              <div className="bg-teal-50 rounded-xl p-5 text-center">
                <div className="text-3xl font-extrabold text-teal-600 mb-1">18–23%</div>
                <p className="text-sm text-gray-600">рост конверсии месяц к месяцу</p>
              </div>
              <div className="bg-teal-50 rounded-xl p-5 text-center">
                <div className="text-3xl font-extrabold text-teal-600 mb-1">+20%</div>
                <p className="text-sm text-gray-600">в среднем за период сопровождения</p>
              </div>
            </div>
            <div className="text-sm text-gray-600 space-y-1">
              <p><i className="ri-check-line text-teal-600 mr-2"></i>Аудит 120+ переговорных записей</p>
              <p><i className="ri-check-line text-teal-600 mr-2"></i>Разработана переговорная матрица</p>
              <p><i className="ri-check-line text-teal-600 mr-2"></i>2-дневный интенсив + 3 месяца сопровождения</p>
            </div>
          </div>

          {/* Case 2 */}
          <div className="bg-white rounded-2xl p-8 md:p-10 shadow-sm">
            <div className="flex items-center gap-4 mb-6">
              <div className="w-14 h-14 bg-teal-600 rounded-xl flex items-center justify-center flex-shrink-0">
                <i className="ri-shopping-bag-3-line text-2xl text-white"></i>
              </div>
              <div>
                <h3 className="text-xl md:text-2xl font-bold text-gray-900">B2C продажи товаров</h3>
                <p className="text-gray-500 text-sm">Розничные продажи через консультации</p>
              </div>
            </div>
            <div className="grid sm:grid-cols-2 gap-4 mb-6">
              <div className="bg-teal-50 rounded-xl p-5 text-center">
                <div className="text-3xl font-extrabold text-teal-600 mb-1">+55%</div>
                <p className="text-sm text-gray-600">рост конверсии после серии тренингов</p>
              </div>
              <div className="bg-teal-50 rounded-xl p-5 text-center">
                <div className="text-3xl font-extrabold text-teal-600 mb-1">+$116 000</div>
                <p className="text-sm text-gray-600">рост валовой прибыли</p>
              </div>
            </div>
            <div className="text-sm text-gray-600 space-y-1">
              <p><i className="ri-check-line text-teal-600 mr-2"></i>Аудит скриптов и записей разговоров</p>
              <p><i className="ri-check-line text-teal-600 mr-2"></i>Новая стратегия: от цены к экспертизе</p>
              <p><i className="ri-check-line text-teal-600 mr-2"></i>Интенсив с отработкой возражений</p>
            </div>
          </div>

          {/* Case 3 */}
          <div className="bg-white rounded-2xl p-8 md:p-10 shadow-sm">
            <div className="flex items-center gap-4 mb-6">
              <div className="w-14 h-14 bg-teal-600 rounded-xl flex items-center justify-center flex-shrink-0">
                <i className="ri-service-line text-2xl text-white"></i>
              </div>
              <div>
                <h3 className="text-xl md:text-2xl font-bold text-gray-900">Консьерж-сервис</h3>
                <p className="text-gray-500 text-sm">Продление договоров, подписки</p>
              </div>
            </div>
            <div className="grid sm:grid-cols-2 gap-4 mb-6">
              <div className="bg-teal-50 rounded-xl p-5 text-center">
                <div className="text-3xl font-extrabold text-teal-600 mb-1">64% → 84%</div>
                <p className="text-sm text-gray-600">рост продлений договоров</p>
              </div>
              <div className="bg-teal-50 rounded-xl p-5 text-center">
                <div className="text-3xl font-extrabold text-teal-600 mb-1">×9</div>
                <p className="text-sm text-gray-600">рост долгосрочных оплат</p>
              </div>
            </div>
            <div className="text-sm text-gray-600 space-y-1">
              <p><i className="ri-check-line text-teal-600 mr-2"></i>Изменена модель переговоров о продлении</p>
              <p><i className="ri-check-line text-teal-600 mr-2"></i>Средний чек вырос благодаря долгосрочным оплатам</p>
              <p><i className="ri-check-line text-teal-600 mr-2"></i>Внедрён еженедельный разбор сложных кейсов</p>
            </div>
          </div>
        </div>

        <div className="text-center mt-12">
          <button
            onClick={() => scrollTo('contact')}
            className="bg-teal-600 text-white px-8 py-4 rounded-lg text-base font-semibold hover:bg-teal-700 transition-all transform hover:scale-105 whitespace-nowrap cursor-pointer inline-flex items-center gap-2"
          >
            Хочу такой же результат
            <i className="ri-arrow-right-line"></i>
          </button>
        </div>
      </div>
    </section>
  );
}